export default {
  "indentZero": "_1tA8x",
  "indentOne": "ULFtf",
  "indentTwo": "ZiTj1",
  "indentThree": "M6s5A",
  "indentFour": "Of4M-",
  "indentFive": "VuR1Y",
  "indentSix": "RdQsK"
};